import React, { useContext, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import { WarehouseInventoryV2Api } from 'api/warehouseInventoryV2';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications } from 'shared';

const warehouseInventoryV2Api = new WarehouseInventoryV2Api();

function ActiveNegativeVariance({}) {
    const [notification, setNotification] = useState({ text: null, level: null });
    const [rows, setRows] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const { user } = useContext(UserContext);
    const [confirming, setConfirming] = useState(false);

    const handleOpenConfirmDialog = (row) => {
        setSelectedRow(row);
        setConfirmDialogOpen(true);
    };

    const handleCloseConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setSelectedRow(null);
    };

    const overrideNegativeVariance = async () => {
        if (!selectedRow) return;

        setConfirming(true);
        const { companySourceId, itemType, sku } = selectedRow.original;

        let packagingId = null;
        let externalSku = null;
        if (itemType === 'Packaging') {
            packagingId = sku;
        } else {
            externalSku = sku;
        }

        const res = await warehouseInventoryV2Api.overrideNegativeVariance(
            packagingId,
            externalSku,
            user.facilityID,
            companySourceId,
        );
        setConfirming(false);
        if (!res.status) {
            setNotification({ text: res.msg, level: 'error' });
            handleCloseConfirmDialog();
            return;
        }

        setNotification({ text: 'Negative variance cleared for sku', level: 'success' });
        handleCloseConfirmDialog();
        getNegativeVariance();
    };

    // Column Definitions
    const columns = [
        { Header: 'Partner SKU', accessor: 'partnerSku' },
        { Header: 'Partner Name', accessor: 'companySource' },
        { Header: 'MM SKU', accessor: 'sku' },
        { Header: 'Item Type', accessor: 'itemType' },
        { Header: 'Item Name', accessor: 'itemName' },
        { Header: 'Negative Variance Units', accessor: 'unresolvedUnits' },
        { Header: 'Last Known Location', accessor: 'warehouseLocationName' },
    ];

    if (user.canOverrideNegativeVariance) {
        columns.push({
            Header: 'Override',
            Cell: ({ row }) => <Button onClick={() => handleOpenConfirmDialog(row)}>Override</Button>,
        });
    }

    useEffect(() => {
        getNegativeVariance();
    }, []);

    // API call to GET data
    const getNegativeVariance = async () => {
        const result = await warehouseInventoryV2Api.getActiveNegativeVariance(user.facilityID);
        if (result.status) {
            setRows(result.data.items);
        } else {
            setNotification({ text: result.msg, level: 'error' });
        }
    };

    return (
        <>
            <Notifications options={notification} />
            <DataTable columns={columns} data={rows} />

            <Dialog open={confirmDialogOpen} onClose={handleCloseConfirmDialog}>
                <DialogTitle>Confirm Override</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to override the negative variance for {selectedRow?.original?.itemName}{' '}
                        (SKU: {selectedRow?.original?.sku})? This will clear {selectedRow?.original?.unresolvedUnits}{' '}
                        units of negative variance.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmDialog} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={overrideNegativeVariance}
                        color="primary"
                        variant="contained"
                        disabled={confirming}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export { ActiveNegativeVariance };
